import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FileUpload } from 'primeng/fileupload';
import { finalize } from 'rxjs/operators';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { FacilityService } from 'src/app/core/services/facility.service';
import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { DeliveryOrderService } from 'src/app/features/transport-operation/services/delivery-order.service';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { DailyRateService } from '../../service/daily-rate.service';
import * as xlsx from 'xlsx';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';

@Component({
  selector: 'laas-daily-rate-setting',
  templateUrl: './daily-rate-setting.component.html',
  styleUrls: ['./daily-rate-setting.component.scss']
})
export class DailyRateSettingComponent extends SessionBaseComponent implements OnInit {
  readonly permissionCode: string = PermissionConstants.ViewDailyRateSetting;
  currentLang: string = this.laasSetting.language;
  readonly preferenceKey: string;
  isActivatedOptions: any;
  columns: any[];
  isSearchFormOpen: boolean;
  searchParams: any;
  searchForm: FormGroup;
  dailyRateRows: any[];
  isLoading: boolean;
  isShowImportdailyRateModal: boolean;
  currencyOptions: any[];
  rateTypeOptions: any[];


  constructor(
    private facilityService: FacilityService,
    private dailyRateService: DailyRateService,
    private commonDataService: CommonDataService,
    injector: Injector,
    private fb: FormBuilder,
    private datePipe: DatePipe
  ) {
    super(injector);
    this.preferenceKey = UserPreferenceConstants.DailyRateSetting;
    this.isSearchFormOpen = true;
    this.isLoading = false;
    this.isShowImportdailyRateModal = false;
    this.dailyRateRows = [];
    this.currencyOptions = [];
    this.rateTypeOptions = [];


    this.columns = [
      { field: 'rateType', header: 'ExchangeRate.MainTable.ExchangeType', sort: true },
      { field: 'date', header: 'ExchangeRate.MainTable.Date', sort: true },
      { field: 'fromCurrency', header: 'ExchangeRate.MainTable.OriginExchangeRate', sort: true },
      { field: 'toCurrency', header: 'ExchangeRate.MainTable.ConversionRate', sort: true },
      { field: 'rate', header: 'ExchangeRate.MainTable.ExchangeRate', sort: true },
      { field: 'rateYM', header: 'ExchangeRate.MainTable.ExchangeRateRange', sort: true },
      { field: 'isActivated', header: 'ExchangeRate.MainTable.IsValid', sort: true },
      { field: 'createUser', header: 'ExchangeRate.MainTable.Creator', sort: true },
      { field: 'createDt', header: 'ExchangeRate.MainTable.CreationTime', dataType: 'date', sort: true },
      { field: 'updateUser', header: 'ExchangeRate.MainTable.UpdateBy', sort: true },
      { field: 'updateDt', header: 'ExchangeRate.MainTable.UpdateTime', dataType: 'date', sort: true },
      { field: '__action', header: 'Action', sort: false },
    ];

    this.searchParams = {
      rateType: '',
      fromCurrency: '',
      toCurrency: '',
      isActivated: '1'
    };

    this.searchForm = this.fb.group({
      rateType: '',
      fromCurrency: '',
      toCurrency: '',
      isActivated: '1'
    });

    this.isActivatedOptions = [];
  }

  async ngOnInit(): Promise<void> {
    this.logger.info('DailyRateSettingComponent onInit.');
    await super.ngOnInit();

    this.isActivatedOptions = [
      { label: 'Y', value: '1' },
      { label: 'N', value: '0' }
    ];

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'RateType').subscribe({
      next: result => {
        this.rateTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeKey}-${x.codeDesc}`,
            value: x.codeKey,
          };
        });
      }
    });

    this.facilityService.getCurrencyOptions().subscribe({
      next: result => {
        this.currencyOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
        this.translateService.get('Common.Message.ChooseOption')
          .subscribe({
            next: msg => {
              this.currencyOptions.unshift({
                label: msg,
                value: ""
              });


            }
          });

      }
    });

    // var canInPage = this.permissionCodes.includes(this.permissionCode);
    // if (!canInPage) {
    //   // go unAuthorize
    //   this.routeStateService.navigateTo('/Error/unAuthorize');
    // }
  }

  /**
   * sku field add event.
   * @param event p-chips onAdd event.
   */
  skuChipsAdd(event: any): void {
    const value: string = event.value;
    const parsedValues: string[] = value.split('\r\n').filter(x => isNullOrEmpty(x) === false && x !== '\r\n');
    this.searchParams.sku.splice(this.searchParams.sku.indexOf(value));
    this.searchParams.sku = this.searchParams.sku.concat(parsedValues);
  }

  searchClickBtn(event: any): void {
    console.log('params: ' + JSON.stringify(this.searchParams));
    this.isLoading = true;

    this.dailyRateService.getDailyRate(this.searchParams)
      .pipe(finalize(() => {
        this.isLoading = false;
        this.isSearchFormOpen = false;
      }))
      .subscribe({
        next: result => {
          console.log(result);
          this.dailyRateRows = result;
        }
      });
  }

  resetClickBtn(event: any): void {
    this.searchForm.reset();
  }

  addClickBtn(event: any): void {
    this.routeStateService.navigateTo('/Setting/DailyRateSettingAdd', true);
  }

  importClickBtn(event: any): void {
    this.isShowImportdailyRateModal = true;
  }

  exportClickBtn(event: any): void {
    const dataRows = [];
    for (const item of this.dailyRateRows) {
      const row = {} as any;
      for (const column of this.columns) {
        if (item.hasOwnProperty(column.field)) {
          let value = item[column.field];
          console.log(value);
          switch (column.field) {
            case 'date':
              value = this.datePipe.transform(value, 'yyyy-MM-dd', this.laasSetting.facilityTimeZone);
              break;
            case 'fromCurrency':
              value = this.currencyOptions.find((x: any) => x.value === value)?.label;
              break;
            case 'toCurrency':
              value = this.currencyOptions.find((x: any) => x.value === value)?.label;
              break;
            case 'isActivated':
              value = this.isActivatedOptions.find((x: any) => x.value === value)?.label;
              break;
            default:
              break;
          }
          switch (column.dataType) {
            case 'date':
              value = this.datePipe.transform(value, 'yyyy-MM-dd HH:mm:ss', this.laasSetting.facilityTimeZone);
              break;
            default:
              break;
          }
          row[column.header] = value;
        }
      }
      dataRows.push(row);
    }

    const worksheet = xlsx.utils.json_to_sheet(dataRows);
    const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data: Blob = new Blob(
      [excelBuffer],
      { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' }
    );
    const url = URL.createObjectURL(data);
    const linkEle = document.createElement('a');
    linkEle.href = url;
    linkEle.download = 'Exhange Rate Result';
    linkEle.click();
    URL.revokeObjectURL(url);
    linkEle.remove();
  }

  actionBtnClick(event: any, rowData: any): void {
    this.routeStateService.navigateTo('/Setting/DailyRateSettingDetail', rowData, true);
  }

  importdailyRate(event: any): void {
    this.isShowImportdailyRateModal = false;
  }

}
